// VFX: Bar Chart Reveal
// Category: bar-charts  ·  Tags: data, chart, bar, kpi, metrics
// Horizontal bar chart with stagger growth.
import React from "react";
import {AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate} from "remotion";
const clamp = {extrapolateLeft:"clamp",extrapolateRight:"clamp"} as const;
type BarItem = {label:string; value:number; color?:string};
export const BarChartReveal: React.FC<{
  items?: BarItem[]; maxValue?: number; title?: string;
  dark?: boolean; barHeight?: number;
}> = ({
  items=[{label:"Revenue",value:87,color:"#34d399"},{label:"Retention",value:64,color:"#60a5fa"},{label:"NPS",value:92,color:"#f472b6"},{label:"CAC",value:45,color:"#fbbf24"}],
  maxValue=100, title="KPIs do Quarter", dark=true, barHeight=36
}) => {
  const frame = useCurrentFrame();
  const {fps} = useVideoConfig();
  const bg = dark?"#0a0a0c":"#f8fafc";
  const textColor = dark?"#f0f0f0":"#1a1a2e";
  const mutedColor = dark?"#666":"#888";
  return (
    <AbsoluteFill style={{justifyContent:"center",alignItems:"center",background:bg}}>
      <div style={{width:580}}>
        {title && (
          <div style={{
            fontSize:16, fontWeight:600, color:mutedColor, letterSpacing:"2px",
            textTransform:"uppercase", marginBottom:32, fontFamily:"system-ui",
            opacity: spring({frame, fps, config:{damping:200,stiffness:100}}),
          }}>{title}</div>
        )}
        {items.map((item,i) => {
          const delay = 10 + i * 12;
          const p = spring({frame:frame-delay, fps, config:{damping:160, stiffness:140}});
          const barW = (item.value/maxValue) * 100 * p;
          return (
            <div key={i} style={{marginBottom:20, opacity:interpolate(frame,[delay,delay+10],[0,1],clamp)}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                <span style={{fontSize:15,fontWeight:500,fontFamily:"system-ui",color:textColor}}>{item.label}</span>
                <span style={{fontSize:15,fontWeight:700,fontFamily:"system-ui",color:item.color||"#6366f1"}}>
                  {Math.round(item.value*p)}%
                </span>
              </div>
              <div style={{height:barHeight,borderRadius:8,background:dark?"rgba(255,255,255,0.06)":"rgba(0,0,0,0.06)"}}>
                <div style={{
                  height:"100%", borderRadius:8, width:`${barW}%`,
                  background:`linear-gradient(90deg, ${item.color||"#6366f1"}cc, ${item.color||"#6366f1"})`,
                  boxShadow:`0 0 12px ${item.color||"#6366f1"}44`,
                  minWidth: p > 0.01 ? 8 : 0,
                }} />
              </div>
            </div>
          );
        })}
      </div>
    </AbsoluteFill>
  );
};

export default function DataBarChartReveal1200Ms() {
  return <BarChartReveal />;
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
